import { render, staticRenderFns } from "./VLeadApplicants.vue?vue&type=template&id=ff876948&scoped=true"
import script from "./VLeadApplicants.vue?vue&type=script&lang=js"
export * from "./VLeadApplicants.vue?vue&type=script&lang=js"
import style0 from "./VLeadApplicants.vue?vue&type=style&index=0&id=ff876948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff876948",
  null
  
)

export default component.exports